/**
 * ========================================
 * FEEDBACK SYSTEM
 * ========================================
 * Handles feedback modal and email submission
 */

// Feedback elements
const btnFeedback = document.getElementById('btn-feedback')
const feedbackModal = document.getElementById('feedback-modal')
const btnCloseFeedback = document.getElementById('btn-close-feedback')
const feedbackForm = document.getElementById('feedback-form')

// Open feedback modal
btnFeedback.addEventListener('click', () => {
    feedbackModal.classList.add('active')
})

// Close feedback modal via close button
btnCloseFeedback.addEventListener('click', () => {
    feedbackModal.classList.remove('active')
})

// Close feedback modal when clicking on overlay background
feedbackModal.addEventListener('click', (e) => {
    if (e.target === feedbackModal) {
        feedbackModal.classList.remove('active')
    }
})

// Handle feedback form submission
feedbackForm.addEventListener('submit', (e) => {
    e.preventDefault()

    // Get form values
    const name = document.getElementById('feedback-name').value
    const email = document.getElementById('feedback-email').value
    const message = document.getElementById('feedback-message').value

    const yourEmail = 'aruman@livingleafstudio.com'
    const subject = encodeURIComponent(`Feedback from ${name}`)
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`)

    window.location.href = `mailto:${yourEmail}?subject=${subject}&body=${body}`

    // Close modal and reset form
    setTimeout(() => {
        feedbackModal.classList.remove('active')
        feedbackForm.reset()
    }, 500)

    // Show success message (optional)
    alert('Thank you for your feedback! Your email client will open.')

    
})
